<template lang="pug">
  #app
    canvas#renderCanvas( width="960", height="540" )

    #scene
      scene-opening( v-if="scene==='opening'", @onSceneNext="onSceneOpeningNext" )
      scene-achievement( v-if="scene==='achievement'", @onSceneNext="onSceneAchievementNext" )     
      scene-play( v-if="scene==='play'" )
    
    transition( name="wipe" )
      #wipe( v-if="fadeStatus" )
      
    transition( name="wipe" )
      Loading( 
        v-if="scene==='loading'",
        :loaded="loaded",
        :loadTotal="loadTotal"
      )
</template>

<script>
import GameMain from "./game/GameMain";
import SceneOpening from "./components/SceneOpening";
import SceneAchievement from "./components/SceneAchievement";
import ScenePlay from "./components/ScenePlay";
import Loading from "./components/Loading";

export default {
  name: "app",
  components: {
    SceneOpening,
    SceneAchievement,
    ScenePlay,
    Loading
  },

  data() {
    return {
      fadeStatus: true,
      scene: "loading",
      loaded: 0,
      loadTotal: 0
    };
  },

  mounted() {
    document.addEventListener("DOMContentLoaded", () => {
      GameMain.init(this.onSceneInitComplete);
      this.sceneLoadCheck();
    });
  },

  methods: {
    sceneLoadCheck() {
      let loadStatus = GameMain.getSceneLoadStatus();
      this.loaded = loadStatus.loaded;
      this.loadTotal = loadStatus.loadTotal;

      if (this.loaded < this.loadTotal) {
        setTimeout(() => {
          this.sceneLoadCheck();
        }, 100);
      }
    },

    onSceneInitComplete() {
      //this.onSceneAchievementNext();
      //this.onSceneOpeningNext();
      GameMain.sceneChange("opening");
      this.scene = "opening";

      setTimeout(() => {
        this.fadeStatus = false;
      }, 1000);
    },

    onSceneOpeningNext() {
      //this.fadeStatus = true;

      setTimeout(() => {
        GameMain.sceneChange("achievement");
        this.scene = "achievement";
        //this.fadeStatus = false;
      }, 1000);
    },

    onSceneAchievementNext() {
      //this.fadeStatus = true;

      setTimeout(() => {
        //this.fadeStatus = false;
        GameMain.sceneChange("play");
        this.scene = "play";
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
@import "./assets/html-5-reset-css.css";
@import "./assets/main.scss";
@import "./assets/description.scss";
@import "./assets/parts.scss";
@import "./assets/transition.scss";

@font-face {
  font-family: "ELECNA";
  src: url("/fonts/ELECNA__.TTF") format("truetype");
}
</style>
